module.exports = __webpack_public_path__ + "data/50m.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]&outputPath=data/!./src/data/50m.json
// module id = 30
// module chunks = 0